var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['base-textareainput-container', ..._vm.styles]},[_c('textarea',_vm._g(_vm._b({ref:"inputElement",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.checkValidity}},'textarea',_vm.$attrs,false),_vm.inputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }